import PeriodList from "@/controllers/academic_period/period-list.js";

export default {
  extends: PeriodList,
};
